const { isEmpty } = require('lodash');

class AddressEntryFormController {
    constructor($q, moveFocus, addressService, fulfilmentService, addressEntryModes) {
        this.$q = $q;
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.addressEntryModes = addressEntryModes;
    }

    set addressEntryMode(mode) {
        this.entryMode = mode;
        if (this.onSetEntryMode) {
            this.onSetEntryMode({ mode });
        }
    }

    get addressEntryMode() {
        return this.entryMode;
    }

    $onInit() {
        if (this.isNewFulfilmentMethodSelector) {
            this.autocompleteText = this.fulfilmentService.getFullDeliveryAddress(this.selectedAddress);
        }
        this.shouldResetMode = this.shouldResetMode !== undefined ? this.shouldResetMode : true;
        this.shouldFocusInitially = this.shouldFocusInitially !== undefined ? this.shouldFocusInitially : true;
        if (!this.isNewFulfilmentMethodSelector) {
            this.clearInput();
        }
        if (!this.initialAddress) {
            this.addressEntryMode = this.addressEntryModes.search;
        }
        this.address = null;
        if (this.shouldFocusInitially && !this.isNewFulfilmentMethodSelector) {
            this.moveFocus(`#address-${this.inputId}`);
        }
    }

    $onChanges(changes) {
        if (changes.initialAddress && this.initialAddress) {
            this.setEntryMode(this.addressEntryModes.manual);
        }

        if (changes.selectedAddress && this.isNewFulfilmentMethodSelector) {
            this.autocompleteText = this.fulfilmentService.getFullDeliveryAddress(this.selectedAddress);
        }
    }

    getItemText(item) {
        return item.Text ? item.Text : item.AddressText;
    }

    addressOnType() {
        if (this.isNewFulfilmentMethodSelector) {
            this.selectedAddress = null;
            if (!!this.autocompleteText && this.autocompleteText.length >= 3) {
                this.addressService._clearAutoAddresses();
                return this.addressService.addressOnType(this.autocompleteText);
            }
            const deferred = this.$q.defer();
            deferred.resolve(this.savedAddresses);
            return deferred.promise;
        }

        return this.addressService.addressOnType(this.autocompleteText);
    }

    clearInput() {
        this.autocompleteText = this.addressQuery ? this.addressQuery.AddressText : '';
    }

    saveSearchedAddress(address) {
        if (this.isNewFulfilmentMethodSelector) {
            if (!isEmpty(address)) {
                if (typeof address.Id !== 'undefined') {
                    this.onSaveAutoAddress({ address });
                } else {
                    this.onSavedAddressSelected({ address });
                }
                return;
            }
        }

        if (this.onSaveAutoAddress) {
            this.onSaveAutoAddress({ address });
        }
        if (!this.shouldRetainInput) {
            this.clearInput();
        } else {
            this.autocompleteText = address.Text;
        }
    }

    saveManualAddress(address) {
        if (address.suburbId && address.suburbId > 0) {
            if (this.onSaveManualAddress) {
                this.$q.when(this.onSaveManualAddress({ address })).then(() => {
                    if (this.shouldResetMode) {
                        this.setEntryMode(this.addressEntryModes.search);
                    }
                });
            }
            if (!this.shouldRetainInput) {
                this.clearInput();
            }
        }
    }

    setEntryMode(mode) {
        this.addressEntryMode = mode;
        if (mode === this.addressEntryModes.search) {
            this.moveFocus(`#address-${this.inputId}`);
        }
        this.address = null;
    }
}

AddressEntryFormController.$inject = ['$q', 'MoveFocus', 'AddressService', 'FulfilmentService', 'AddressEntryModes'];

const addressEntryFormComponentDefinition = {
    bindings: {
        inputId: '@',
        addressQuery: '<?',
        showSubmit: '=?',
        messageOnError: '@?',
        shouldFocusInitially: '<?',
        shouldResetMode: '<?',
        shouldRetainInput: '<?',
        onSaveAutoAddress: '&?',
        onSavedAddressSelected: '&?',
        onSaveManualAddress: '&?',
        onManualAddressChange: '&?',
        onSetEntryMode: '&?',
        initialAddress: '<?',
        savedAddresses: '=?',
        isNewFulfilmentMethodSelector: '<?',
        selectedAddress: '<?',

        // Express Delivery specific bindings.
        isForExpress: '<?',
        isExpressUnavailable: '<?',
        manualAddressMode: '@?',
        onValidateManualAddressForExpress: '&?',
        onShopManualAddressForExpress: '&?',
    },
    controller: AddressEntryFormController,
    template: require('./address-entry-form.component.html').trim(),
};

module.exports = {
    AddressEntryFormController,
    addressEntryFormComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/address/address-entry-form.component.js